import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

import { System } from 'features/systems/domain/models/system';
import styles from './ip-unit-functionalities.module.scss';

type Props = {
  system: System;
};

const IpUnitFunctionalities = ({ system }: Readonly<Props>): React.JSX.Element => {
  const { t } = useTranslation('systems');

  const hasAnyFunctionality = system.audioRecorderAvailable || system.intercomFunctionalityAvailable || system.ioFunctionalityAvailable;

  return hasAnyFunctionality ? (
    <div className={styles.informationItem}>
      <Typography variant="h5">{t('details.information.availableFunctionalitiesLabel')}</Typography>
      <ul>
        {system.audioRecorderAvailable && (
          <li>
            <Typography variant="subtitle1">{t('details.information.audioRecorderFunctionalityLabel')}</Typography>
          </li>
        )}
        {system.intercomFunctionalityAvailable && (
          <li>
            <Typography variant="subtitle1">{t('details.information.intercomFunctionalityLabel')}</Typography>
          </li>
        )}
        {system.ioFunctionalityAvailable && (
          <li>
            <Typography variant="subtitle1">{t('details.information.ioFunctionalityLabel')}</Typography>
          </li>
        )}
      </ul>
    </div>
  ) : (
    <></>
  );
};

export default IpUnitFunctionalities;
